var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    d: "M24.4,0H1.6C0.7,0,0,0.7,0,1.6v22.8C0,25.3,0.7,26,1.6,26h22.8c0.9,0,1.6-0.7,1.6-1.6V1.6 C26,0.7,25.3,0,24.4,0z M24.4,24.4H1.6V1.6h22.8V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    d: "M6.1,8.9h14.6c0.2,0,0.4-0.2,0.4-0.4V7.7c0-0.2-0.2-0.4-0.4-0.4H6.1c-0.2,0-0.4,0.2-0.4,0.4v0.8 C5.7,8.8,5.9,8.9,6.1,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    d: "M6.1,13.8h14.6c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H6.1c-0.2,0-0.4,0.2-0.4,0.4v0.8 C5.7,13.6,5.9,13.8,6.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    d: "M6.1,18.7h12.2c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H6.1c-0.2,0-0.4,0.2-0.4,0.4v0.8 C5.7,18.5,5.9,18.7,6.1,18.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/Paragraph.7c17b88d7a80b9919846a712d295e630.svg";
export { ForwardRef as ReactComponent };